import * as chains from "./chains";
import type { ValidChainId, } from "@bracket/chainography";
import type { ValidConnectorName, ChainInfo, } from "./types";

export const VALID_CHAINS: ValidChainId[] = [
	1,
	42161,
];

export const VALID_CONNECTORS: ValidConnectorName[] = [
	"injected",
	"MetaMask",
	"WalletConnect",
	"Coinbase Wallet",
];

export const VALID_CHAIN_NAME = [
	"arbitrum",
	"mainnet",
];

export const VALID_CHAINID_MAP: Record<ValidChainId, ChainInfo> = {
	1: chains.mainnet,
	42161: chains.arbitrum,
};

export const VALID_CHAINNAME_MAP: Record<ValidChainId, ChainInfo> = {
	1: chains.mainnet,
	42161: chains.arbitrum,
}
